import { useNavigate } from 'react-router-dom';

import { classNames } from "~/utils/utils";
import Links from "~/components/Links";
import HeaderLogo from "~/components/HeaderLogo";
import type { ITemplateUser } from "~/interfaces";
import { layoutStore } from "~/stores/layout";
import { getLink } from '~/providers/route';

import "./style.less";

export default function LeftMenu({
	projectId = 0,
	keyId = 0,
	checkInternalRole = "none",
}: ITemplateUser) {
	const { smallLayout, showLeftMenu, setShowLeftMenu, compact, setCompact } = layoutStore(layoutState => ({
		compact: layoutState.layout.compact,
		smallLayout: layoutState.layout.smallLayout,
		showLeftMenu: layoutState.layout.showLeftMenu,
		setShowLeftMenu: layoutState.setShowLeftMenu,
		setCompact: layoutState.setCompact,
	}));
	const navigate = useNavigate();

	function getClassName(): string {
		return classNames([
			"leftMenu",
			...compact ? ["compact"] : [],
			...showLeftMenu ? ["responsive-version"] : [],
		]);
	}

	function headerClick() {
		if (showLeftMenu) {
			setShowLeftMenu(false);
		} else {
			setCompact(!compact);
		}
	}

	function logoClick() {
		if (checkInternalRole === "none") {
			navigate(getLink("projects"));
		} else {
			navigate(getLink("admin-projects"));
		}
	}

	return showLeftMenu || !smallLayout
		? <div className={getClassName()}>
			<HeaderLogo onClick={headerClick} onLogoClick={logoClick} compact={compact} />
			<div className="leftMenu__linksSection">
				<Links projectId={projectId} keyId={keyId} checkInternalRole={checkInternalRole} />
			</div>
		</div>
		: null;
}
